module.exports = "https://coursera_assets.s3.amazonaws.com/images/e2b69a24b89ae636a20ad7dc1fb6cb8f.png";